import React from 'react';
import styled from 'styled-components';
import { CheckboxList, Loader } from '../../../../UiKit';
import { Card } from '../../ReportIssue/Issues/common';
import { EmptyState } from '../../../commons';
import { InvalidSearchImg } from '../../../../images/images';
import { useMutationCall, useQueryCall } from '../../../../api/react-client';
import { lifelineEndPoints } from '../../../../api/end-points';
import Button from '../../../ComponentsV1/Button';

function EditValetInstruction({ closeModal, orderId, refetchInstruction }) {
  return (
    <EditInstructionscomp
      closeModal={closeModal}
      orderId={orderId}
      refetchInstruction={refetchInstruction}
    />
  );
}

export default EditValetInstruction;

const EditInstructionscomp = ({ closeModal, orderId, refetchInstruction }) => {
  const queryKeys = ['set_delivery_instructions', orderId];
  const getEligibleInstructionsEndPoint = `${lifelineEndPoints.GET_ELIGIBLE_INSTRUCTIONS}/${orderId}`;
  const updateInstructionEndPoint = `${lifelineEndPoints.POST_UPDATE_INSTRUCTIONS}/delivery_instructions/set_delivery_instructions/${orderId}`;

  let { data, isLoading, isError } = useQueryCall(
    { cacheTime: 0 },
    getEligibleInstructionsEndPoint,
    queryKeys,
  );

  const { mutate, isLoading: settingInstruction } = useMutationCall(
    {
      onSettled: () => {
        refetchInstruction(orderId);
        closeModal();
      },
    },
    updateInstructionEndPoint,
    ['set_delivery_instructions'],
  );

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return (
      <EmptyState img={InvalidSearchImg} heading='Something went wrong.' />
    );
  }

  const eligibileInstruction =
    data?.instructions.map((item) => {
      return {
        type: item.slug,
        text: (
          <div
            css={`
              font-size: 1.7rem;
              margin-bottom: 1rem;
              margin-left: 1.3rem;
              color: #333;
              font-weight: 400;
              font-family: 'Okra';
            `}
          >
            {item.text}
          </div>
        ),
        selected: item.selected,
      };
    }) || [];

  let selectedInstructions = eligibileInstruction
    .filter((item) => {
      return item.selected;
    })
    .map((item) => item.type);

  const saveInstructions = () => {
    mutate({
      instructions: selectedInstructions,
    });
  };

  return (
    <>
      {data?.toast && (
        <div className='tw-mt-6'>
          <Card
            content={{
              text: data.toast,
              type: 'warning',
              bg_color: '#FFFDF6',
              border_color: '#E4B96E',
              color: '#9F6E1A',
            }}
          />
        </div>
      )}
      {eligibileInstruction.length === 0 && (
        <EmptyState img={InvalidSearchImg} heading='No Eligible Instruction' />
      )}
      {eligibileInstruction.length && (
        <>
          <CheckboxList
            items={eligibileInstruction}
            selectOptions={(options) => {
              selectedInstructions = options;
            }}
            alreadyChecked={selectedInstructions}
          />
          <EditInstructionscomp.Actions>
            <Button type='secondary' title='Cancel' onClick={closeModal} />
            <Button
              title='Save'
              loading={settingInstruction}
              onClick={saveInstructions}
            />
          </EditInstructionscomp.Actions>
        </>
      )}
    </>
  );
};

EditInstructionscomp.Actions = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 1rem;
  margin-bottom: 2rem;
`;
